import React, { Suspense, useEffect, useRef, useState } from "react";
import FormCreator from "../../components/Forms/FormCreator";
import Buttons from "../../components/ui/button/Buttons";
import { Accordion } from "react-bootstrap";
import { useLazyGetSignUpDropDownsForCorporateMembersQuery, useStoreBase64ImageMutation } from "../../app/services/common/commonApi";
import SwalAlert from "../../services/swalService/SwalService";
import { setAllDropDownField } from "./Utils/dropDown";
import DataLoader from "../../components/ui/dataLoader/DataLoader";
import { useNavigate, useParams } from "react-router-dom";
import { decryptAESID } from "../../utils/Encryption";
import { viewResourcesDetailFormData } from "./data/CreateResourcesForm.data";
import { useLazyGetResourceDetailByIdQuery } from "../../app/services/Resource/resourceApi";
import { setFieldParameter } from "./Utils/setFieldParameter";

const ViewResourceDetailsForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const editID = id ? decryptAESID(id, false) : 0
  const formRef = useRef();
  const [formData, setFormData] = useState(viewResourcesDetailFormData);
  const [signUpDropDownsForCorporateMembers, { data: signUpDropDownsData, isLoading: signUpDropDownsLoading, isFetching: signUpDropDownsFetching, isError: signUpDropDownsIsError, error: signUpDropDownsError, }] = useLazyGetSignUpDropDownsForCorporateMembersQuery();
  const [getResourceDetail, { data: getResourceDetails, isLoading: getResourceDetailIsLoading, isFetching: getResourceDetailIsFetching, isError: getResourceDetailIsError, error: getResourceDetailError, }] = useLazyGetResourceDetailByIdQuery()

  const handleBack = () => {
    window.history.back();
  };
  
  useEffect(() => {
    signUpDropDownsForCorporateMembers()
    if (id) {
      getResourceDetail(editID)
    }
  }, [id]);

  useEffect(() => {
    if (!getResourceDetailIsLoading && getResourceDetails) {
      setFieldParameter(getResourceDetails);
    }
  }, [getResourceDetailIsLoading, getResourceDetails]);

  useEffect(() => {
    if (!signUpDropDownsLoading && signUpDropDownsData) {
      setAllDropDownField(signUpDropDownsData);
    }
  }, [signUpDropDownsLoading, signUpDropDownsData]);

  return (
    <>
      <div className="create-resources container-fluid">
        <div className="resources-form normal-card p-4 bg-white  rounded">
          {signUpDropDownsData && <Accordion>
            <div className="row">
              <Suspense fallback={<DataLoader />}>
                <FormCreator
                  ref={formRef}
                  {...formData}
                // onFormFieldValueChange={handleFormFieldChange}
                />
              </Suspense>
            </div>
            <div className="d-flex justify-content-between ">
              <Buttons
                buttonText="Back"
                buttonTypeClassName="black-btn"
                onClick={handleBack}
              />
              {/*  <Buttons
              buttonText="Save"
              buttonTypeClassName="success-btn"
              onClick={handleSave}
            /> */}
            </div>
          </Accordion>}
        </div>
      </div>
    </>
  )
}

export default ViewResourceDetailsForm
